import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LazyMotion, MotionConfig } from 'motion/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { useSession } from './api';
import { App } from './App';
import { bootTelegram } from './telegram';
import './styles.css';
// trial look in the spirit of porsche.com — delete this line to roll back
import './theme-porsche.css';

// Motion's animation features load in their own chunk; `m.*` components render at once
const motionFeatures = () => import('./motion-features').then((mod) => mod.default);

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: true } },
});

async function start() {
  if (import.meta.env.VITE_TG_MOCK === '1') {
    const { installMockTelegram } = await import('./mock');
    await installMockTelegram();
  }
  const boot = await bootTelegram();
  useSession.getState().setInitData(boot.initData);
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <LazyMotion features={motionFeatures} strict>
          <MotionConfig reducedMotion="user">
            <App />
          </MotionConfig>
        </LazyMotion>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void start();
